var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRatingStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 14,
    fill: "#F2F4F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2392 14.6069C25.4786 13.8698 26.5214 13.8698 26.7608 14.6069L28.5897 20.2356C28.8842 21.142 29.7289 21.7557 30.682 21.7557H36.6004C37.3754 21.7557 37.6976 22.7474 37.0706 23.2029L32.2826 26.6817C31.5115 27.2419 31.1888 28.2349 31.4834 29.1413L33.3122 34.77C33.5517 35.5071 32.7081 36.12 32.0812 35.6644L27.2931 32.1857C26.5221 31.6255 25.4779 31.6255 24.7069 32.1857L19.9188 35.6644C19.2919 36.12 18.4483 35.5071 18.6878 34.77L20.5166 29.1413C20.8112 28.2349 20.4885 27.2419 19.7174 26.6817L14.9294 23.2029C14.3024 22.7474 14.6246 21.7557 15.3996 21.7557H21.318C22.2711 21.7557 23.1158 21.142 23.4103 20.2356L25.2392 14.6069Z",
    stroke: "#5D6779",
    strokeWidth: 1.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar);
export default __webpack_public_path__ + "static/media/ratingStar.ad8e8247.svg";
export { ForwardRef as ReactComponent };